var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#5C00D1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_45394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 22H12.5L15.5 15L21.5 29L24.5 22H31.5",
    stroke: "#5C00D1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4999 12.0004V10.1504C23.4999 10.6504 22.0999 12.7004 22.5999 15.0004C22.9499 16.4504 24.0999 17.6004 25.4999 17.9004C27.7499 18.4504 29.7999 17.0504 30.3499 15.0004H28.4999C26.8499 15.0004 25.4999 13.6504 25.4999 12.0004Z",
    stroke: "#5C00D1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_45394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8.5 8)"
  })))));
};
export default __webpack_public_path__ + "static/media/ic_rejuvenation.d873b046.svg";
export { SvgComponent as ReactComponent };